<script setup lang="ts">
import type {CertificateFilter, CertificateFilters} from "@/types/Wiser/certificate.ts";
import {onMounted, ref, watch} from "vue";
import {apiClient} from "@/api/http.ts";

const model = defineModel<CertificateFilter>({required: true});
const filters = ref<CertificateFilters>({cursus:''})
watch(filters, (newValue) => {
  const filterString = Object.entries(newValue)
    .filter(([, value]) => value !== '')
    .map(([key, value]) => `${key}${['cursist_voornaam','cursist_achternaam'].includes(key)?'%=':'='}${encodeURIComponent(value)}`)
    .join(',')
  model.value.filters = encodeURI(filterString);
}, {deep: true})
const courses = ref<string[]>([])
const loadCourses = async () => {
  apiClient.get('wiser/cursussen').then((res) => {
    courses.value = res.data
  })
}
onMounted(() => {
  loadCourses()
})
</script>

<template>
  <form class="wiser-filter__form certificate-filter__form">
    <input v-model="filters.id" placeholder="Wiser ID" type="text" />
    <select v-model="filters.cursus">
      <option value="" class="placeholder">Selecteer een cursus</option>
      <option v-for="(course, index) in courses" :key="index" :value="course">{{ course }}</option>
    </select>
    <input v-model="filters.cursist_voornaam" placeholder="Voornaam cursist" type="text" />
    <input v-model="filters.cursist_achternaam" placeholder="Achternaam cursist" type="text" />
    <input v-model="filters.examendatum" placeholder="Examendatum" type="date" />
    <select v-model="model.page">
      <option v-for="num of [...Array(25).keys()]" :value="String(num + 1)">{{ num + 1 }}</option>
    </select>
    <select v-model="model.perPage">
      <option v-for="num of [...Array(4).keys()]" :value="String((num + 1)*25)">{{ (num + 1)*25 }}</option>
    </select>
  </form>
</template>

<style scoped>
 form {
   width: 100%;
 }
</style>
